module.exports = __webpack_public_path__ + "media/site/images/products/ekanban-flat-screen@2x-ecbdb72a753fcb1a42e1b61f18d07b6f.png";